import './App.css';
import Header from "./sections/header/Header";
import Languages from "./sections/languages/Languages";
import CurrentProject from "./sections/current-project/CurrentProject";
import Destinations from "./sections/destinations/Destinations";
import Footer from "./sections/footer/Footer";

function App() {
    return (
        <>
            <Header/>
            <Languages/>
            <CurrentProject/>
            <Destinations/>
            <Footer/>
        </>
    );
}

export default App;
